/*
 * @Description  : 从 ua 获取浏览器的相关信息
 * @usage        : 不能引入 import.meta
 * @Date         : 2021-11-05 15:27:29
 * @Author       : hadeshe<hadeshe@tencent.com>
 * @LastEditors: yukizou yukizou@tencent.com
 * @LastEditTime: 2025-09-12 11:20:32
 * @FilePath: /app-monorepo-projects/packages/app-share/src/utils/no-import-meta/get-browser-obj.ts
 */


// platform 枚举
export enum EPlatformTypes {
  wp = 'wp',
  ios = 'ios',
  android = 'android',
  harmony = 'harmony',
}

// client 枚举
export enum EClientTypes {
  fm = 'fm',
  kg = 'kg',
  qq = 'qq',
  wb = 'wb',
  ws = 'ws',
  wx = 'wx',
  yyb = 'yyb',
  ttpic = 'ttpic',
  qzone = 'qzone',
  Weiyun = 'Weiyun',
  qqmusic = 'qqmusic',
  QQEGame = 'QQEGame',
  QQBrowser = 'QQBrowser',
  QNReading = 'QNReading',
  xinYueClub = 'xinYueClub',
  tencentVideo = 'tencentVideo',
  wsInteractiveSdk = 'wsInteractiveSdk',
}

export class Browser {
  ua = '';
  client = '';
  platform = '';
  isMobile = false;
  isQzoneReview = false;
  os = {
    iPad: false,
    iPhone: false,
    android: false,
    wp: false,
  };
  isQQStudyMode = false;
  constructor(ua: string) {
    const iPad = !!ua.match(/(iPad).*OS\s([\d_]+)/);
    const iPhone = !!(!iPad && ua.match(/(iPhone).*OS\s([\d_]+)/));
    const iPod = !!ua.match(/(iPod).*OS\s([\d_]+)/);
    const android = !!(ua.match(/(Android)\s+([\d.]+)/) || ua.match(/Android/));
    const wp = !!ua.match(/Windows Phone ([\d.]+)/);
    const harmony = !!ua.match(/OpenHarmony (\d+\.?\d*)/);
    const isMobile = iPad || iPhone || iPad || wp || android || harmony;

    this.ua = ua;
    this.isMobile = !!isMobile;

    let platform = '';
    if (iPhone || iPad || iPod) {
      platform = EPlatformTypes.ios;
    } else if (android) {
      platform = EPlatformTypes.android;
    } else if (wp) {
      platform = EPlatformTypes.wp;
    } else if (harmony) {
      platform = EPlatformTypes.harmony;
    }
    /**
     * 平台判断
     * @property {String} platform
     */
    this.platform = platform;

    let client = '';
    const isWX = !!ua.match(/MicroMessenger\/([\d.]+)/); // 微信
    const isQQEGame = !!/\bcom\.tencent\.qgame\/([\d.]+)/.test(ua); // 企鹅电竞
    const isXinYueClub = !!ua.match('tgclub'); // 心悦俱乐部
    const isQQ = !!ua.match(/QQ\/([\d.]+)/); // 手Q
    const isQzone = !!ua.match('Qzone'); // 手空
    const isQQMusic = !!/QQMUSIC\/(\d[.\d]*)/i.test(ua); // qq音乐
    const isFM = !!ua.match('_FM_'); // 企鹅FM
    const isTencentVideo = !!ua.match('QQLiveBrowser');
    const isWSInteractiveSdk = !!ua.match('_WEISHI_INTERACTIVE_H5_SDK_'); // 微视互动h5 sdk
    const isWS = !!ua.match('_WEISHI_'); // 微视
    const isYYB = !!/\/qqdownloader\/(\d+)(?:\/(appdetail|external|sdk))?/.test(ua); // 应用宝
    const isKG = !!ua.match('_KG_'); // K歌
    const isWb = !!ua.match('Weibo'); // weibo
    const isWeiyun = !!ua.match(/Weiyun\/(\d\.)+/); // 微云
    const isPITU = !!ua.match('_PITU_'); // 天天P图，不然就被误认为QQ浏览器了
    const isQQBrowser = !!ua.match('MQQBrowser') && !isQQEGame && !isXinYueClub; // qq浏览器 (QQEGame,xinYueClub ua里面带有MQQBroswer,所以要加这个判断)
    const isQNReading = !!ua.match(/qnreading\/([\d.]*)/i);
    if (isQQ) {
      client = EClientTypes.qq;
    } else if (isQzone) {
      client = EClientTypes.qzone;
    } else if (isWX) {
      client = EClientTypes.wx;
    } else if (isFM) {
      client = EClientTypes.fm;
    } else if (isQQMusic) {
      client = EClientTypes.qqmusic;
    } else if (isWSInteractiveSdk) {
      client = EClientTypes.wsInteractiveSdk;
    } else if (isWS) {
      client = EClientTypes.ws;
    } else if (isTencentVideo) {
      client = EClientTypes.tencentVideo;
    } else if (isYYB) {
      client = EClientTypes.yyb;
    } else if (isWb) {
      client = EClientTypes.wb;
    } else if (isPITU) {
      client = EClientTypes.ttpic;
    } else if (isKG) {
      client = EClientTypes.kg;
    } else if (isWeiyun) {
      client = EClientTypes.Weiyun;
    } else if (isQQEGame) {
      client = EClientTypes.QQEGame;
    } else if (isXinYueClub) {
      client = EClientTypes.xinYueClub;
    } else if (isQQBrowser) {
      // ！！！最后判断QQBrowser，因为很多app的ua里都带有MQQBrowser！！！
      client = EClientTypes.QQBrowser;
    } else if (isQNReading) {
      client = EClientTypes.QNReading;
    }
    /**
     * 主要针对公司几个主要客户端判断
     * @property {String} client
     */
    this.client = client;
    /**
     * 所有平台信息
     * @property {Object} os
     */
    this.os = {
      iPad,
      iPhone,
      android,
      wp,
    };

    /**
     * iOS独立版是否在审核中
     * @property {String} isQzoneReview
     */
    this.isQzoneReview = ua.indexOf('AppstoreReview') >= 0;
    // 是否为(手Q 或 QQ空间)且启用青少年模式
    this.isQQStudyMode = (isQQ || isQzone) && !!(ua.indexOf('StudyMode/1') > -1);
  }
  getOsVersion() {
    let matchResult;
    let ver;
    const { ua } = this;
    if (this.platform === EPlatformTypes.ios) {
      matchResult = ua?.match(/OS\s([\d_.]+)/);
    } else if (this.platform === EPlatformTypes.android) {
      matchResult = ua?.match(/Android[\s/]+([\d_.]+)/);
    } else if (this.platform === EPlatformTypes.harmony) {
      matchResult = ua?.match(/OpenHarmony (\d+\.?\d*)/);
    }
    if (matchResult?.[1]) {
      ver = matchResult[1].replace(/_/g, '.');
    }
    return {
      platform: this.platform,
      version: ver,
    };
  }
  getOsMajorVerNum() {
    const { version = '0' } = this.getOsVersion();
    const osVer = parseInt(version, 10);
    // 如果转化出错，设置osVer为0，默认低版本
    if (!osVer) return 0;
    return osVer;
  }
}

export default function getBrowserObj(userAgent?: string) {
  let ua = userAgent || '';
  if (!ua && typeof navigator !== 'undefined') {
    ua = navigator.userAgent;
  }
  if (!ua) {
    throw new Error('SSR 阶段，必须传入一个ua字符串');
  }
  return new Browser(ua);
}
